import {Component, inject} from '@angular/core';
import {FormTypeEnum} from '../corporate/enums/form-type.enum';
import {NgForOf, NgIf} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {Router} from '@angular/router';
import {MsalService} from '@azure/msal-angular';
import {MatButtonModule} from '@angular/material/button';
import {CustomersOnboardingService} from './services/customers-onboarding.service';
import {TenantContextService} from '../services/tenant-context.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    MatIconModule,
    MatButtonModule
  ],
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent {

  private readonly customersOnboardingService = inject(CustomersOnboardingService);
  private readonly authService = inject(MsalService);
  private readonly tenantContext = inject(TenantContextService);

  /** Organization resolved from the subdomain at startup (e.g. "CODEWISE"); null if unknown. */
  get orgName(): string | null {
    return this.tenantContext.organizationName;
  }

  /** Whether the subdomain resolved to a known Billing tenant. */
  get tenantResolved(): boolean {
    return this.tenantContext.isResolved;
  }

  public options = [
    {
      type: FormTypeEnum.Individual,
      title: 'Individual',
      icon: 'assets/auth/icons/individual.svg',
      description: 'Personal account to manage all your activities.'
    },
    {
      type: FormTypeEnum.Business,
      title: 'Business',
      icon: 'assets/auth/icons/business.svg',
      description: 'Own or belong to a company, this is for you.'
    },
  ];

  private readonly router = inject(Router);

  onNavigate(e: Event, formType: FormTypeEnum) {
    this.customersOnboardingService.getStateStringForOnboarding({clientType: formType}).subscribe();
  }

  login() {
    if (!this.ensureTenant()) return;
    this.customersOnboardingService.redirectToLogin();
    // this.authService.loginRedirect();
  }

  loginAsEmployee() {
    if (!this.ensureTenant()) return;
    this.authService.loginRedirect();
  }

  /** Block sign-in when the subdomain didn't resolve to a known organization. */
  private ensureTenant(): boolean {
    if (this.tenantResolved) return true;
    // eslint-disable-next-line no-alert
    alert('This address is not linked to a known organization. Please check the URL or contact your administrator.');
    return false;
  }
}
